import { decodeJwt } from 'jose';

/**
 * Reads the `exp` claim from a JWT and returns it as an epoch in milliseconds.
 * Returns null when the token is malformed or there is no numeric `exp` claim.
 * We don't verify the signature here — the backend re-validates on every
 * request, so this is only a hint to skip obviously-dead requests.
 */
export function parseJwtExpiry(token: string): number | null {
  try {
    const { exp } = decodeJwt(token);
    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    return null;
  }
}
